import React, { useEffect, useState, useContext } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import './Reservation.css'; // 모달 스타일 포함

function ResourceDetailModal({ resourceId, onClose }) {
  const [resource, setResource] = useState(null);
  const { token } = useContext(AuthContext);

  useEffect(() => {
    const fetchResource = async () => {
      try {
        const res = await axios.get(`/api/resources/${resourceId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setResource(res.data);
      } catch (err) {
        console.error('자원 상세조회 실패:', err);
      }
    };
    if (resourceId) fetchResource();
  }, [resourceId, token]);

  if (!resource) return null;

  return ReactDOM.createPortal(
    <div className="resource-detail-modal">
      <div className="resource-detail-content">
        <h5>자원 상세조회</h5>

        {/* ✅ 본문 전체 스크롤 영역 */}
        <div className="resource-detail-body">
          <div className="mb-3"><strong>자원명:</strong> {resource.res_name}</div>
          <div className="mb-3"><strong>유형:</strong> {resource.res_type}</div>
          <div className="mb-3"><strong>자원구분:</strong> {resource.res_category}</div>
          <div className="mb-3"><strong>상위분류:</strong> {resource.parent_name || '-'}</div>
          <div className="mb-3">
            <strong>색상:</strong>
            <span style={{
              backgroundColor: resource.res_color,
              padding: '4px 12px',
              color: '#fff',
              marginLeft: '8px',
              borderRadius: '4px'
            }}>
              {resource.res_color}
            </span>
          </div>
          <div className="mb-3"><strong>정렬순서:</strong> {resource.sort_order}</div>

          {/* ✅ 설명은 별도 테두리 박스 + 줄바꿈 유지 */}
          <div className="mb-3">
            <strong>설명:</strong>
            <div className="resource-detail-description">
              {resource.description}
            </div>
          </div>
        </div>

        {/* ✅ 닫기 버튼 영역 */}
        <div className="resource-detail-footer">
          <button className="resource-detail-btn" onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ResourceDetailModal;
